import {lazyInject} from '@intelingu/core/IoC/container';
import {VocabularyCardStep, VocabularyCardStore} from '@intelingu/core/stores/cards/VocabularyCardStore';
import {CardStore} from '@intelingu/core/stores/CardStore';
import {computed, when} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {Component} from 'react';
import {SoundComponent} from '../../../partials/SoundComponent';
import {VocabularyAnswer} from './VocabularyAnswer';
import {VocabularyPreview} from './VocabularyPreview';
import {UserStore} from "@intelingu/core/stores/UserStore";

export interface VocabularyCardProps {
    id: number;
}

@observer export class VocabularyCard extends Component<VocabularyCardProps, any> {

    @lazyInject(VocabularyCardStore) vocabularyCardStore: VocabularyCardStore;
    @lazyInject(CardStore) cardStore: CardStore;
    @lazyInject(UserStore) userStore: UserStore;

    audioRef: HTMLAudioElement;
    playFunc;
    modalReaction;
    introReaction;

    constructor(props) {
        super(props);
    }

    @computed get isModalShown() {
        return this.cardStore.isMilestoneAchievementActive || this.cardStore.isLegAchievementActive;
    }

    _renderContent() {
        switch (this.vocabularyCardStore.step) {
            case VocabularyCardStep.PREVIEW:
                return <VocabularyPreview previewPlayFunc={this.playFunc} />;
            case VocabularyCardStep.ANSWER:
                return <VocabularyAnswer />;
            default:
                return null;
        }
    }

    componentDidMount(): void {
        if (this.isModalShown) {
            this.modalReaction = when(() => !this.isModalShown, () => {
                if (!this.isModalShown) {
                    this.playFunc();
                }
            });
        }

        if (!this.userStore.user.intro_finished) {
            this.introReaction = when(() => this.userStore.user.intro_finished, () => {
                if (this.userStore.user.intro_finished) {
                    this.playFunc();
                }
            });
        }

        this.vocabularyCardStore.step = this.cardStore.isChangeMode ?
            VocabularyCardStep.ANSWER :
            VocabularyCardStep.PREVIEW;

        window.scrollTo(0, 0);
    }

    componentDidUpdate(prevProps: Readonly<VocabularyCardProps>, prevState: Readonly<any>, snapshot?: any): void {
        if (prevProps.id !== this.props.id) {
            this.vocabularyCardStore.step = this.cardStore.isChangeMode ?
                VocabularyCardStep.ANSWER :
                VocabularyCardStep.PREVIEW;
        }
    }

    componentWillUnmount(): void {
        if (this.cardStore.isChangeMode) {
            this.vocabularyCardStore.step = VocabularyCardStep.PREVIEW;
        }

        this.vocabularyCardStore.testOdd = !this.vocabularyCardStore.testOdd;

        if (this.modalReaction) {
            this.modalReaction();
        }

        if (this.introReaction) {
            this.introReaction();
        }
    }

    render() {
        const { card } = this.vocabularyCardStore;

        return <div className={'course-card vocabulary-card'}>
            <div className={'vocabulary-source-word'}>
                <span className={'vocabulary-word tour-source-word'}>{ this.vocabularyCardStore.sourceWord }</span>

                { /*!card.inverted && (
                    <SoundComponent
                        audioRef={(ref, play) => this.playFunc = play}
                        autoplay={!this.isModalShown}
                        hotKeyListener={(event, play) => {
                            if (event.key === 'w') {
                                play();
                            }
                        }}
                        url={card.word_translation.audio}
                    />
                )*/}

                { (!card.inverted || this.vocabularyCardStore.step === VocabularyCardStep.ANSWER) && (
                    <div className={'tour-translation-audio'}>
                        <SoundComponent
                            audioRef={(ref, play) => this.playFunc = play}
                            autoplay={this.userStore.user.intro_finished && !this.isModalShown}
                            hotKeyListener={(event, play) => {
                                if (event.key === 'w') {
                                    play();
                                }
                            }}
                            url={card.word_translation.audio}
                        />
                    </div>
                ) }
            </div>

            { this._renderContent() }
        </div>
    }

}
